<template>
  <Teleport to="body">
    <Transition name="dialog-showhide">
      <div
        v-if="visible"
        v-bind="attrs"
        class="dialog"
        :class="{ align: isAlignCenter, justify: isJustifyCenter }"
        :style="{
          'z-index': zIndex ? zIndex : '10',
          backgroundColor: bgclor,
        }"
      >
        <div class="dialog-inner" :style="{ top, left }">
          <div v-if="abledClose" class="btn-close" @click="handleClose">
             <img src="@/assets/images/close-ico.png" alt="close">
          </div>
          <div class="dialog-border">
            <div
              class="dialog-body box-border"
              :style="{ width, minWidth, maxWidth, padding: `${padding}px`, height, 'max-height': maxHeight }"
            >
              <div  class="d-power" v-show="showPower">
                <span class="icon"></span>
                <span>{{ homeStore.powerBalance || 0 }}</span>
              </div>
              <slot />
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
// defineOptions({
//   inheritAttrs: false,
// });

import { useAttrs } from "vue";
import SvgIcon from "@/components/svg.vue";
import useHomeStore from '@/stores/home';
const homeStore = useHomeStore()
const attrs = useAttrs();

interface Props {
  width: string;
  visible: boolean;
  minWidth?: string;
  maxWidth?: string;
  padding?: number;
  abledClose?: boolean;
  showPower?: boolean;
  isAlignCenter?: boolean; // 弹窗是否垂直居中
  isJustifyCenter?: boolean; // 弹窗是否水平居中
  top?: string;
  left?: string;
  zIndex?: number;
  bgclor?: string;
  height?: string;
  maxHeight?: string;
}

const props = withDefaults(defineProps<Props>(), {
  width: "1000px",
  height: "",
  maxHeight: "",
  visible: false,
  minWidth: "unset",
  maxWidth: "unset",
  padding: 24,
  abledClose: true,
  showPower: false,
  isAlignCenter: true,
  isJustifyCenter: true,
  top: '0',
  left: '0',
  zIndex: 10,
  bgclor: 'rgba(0, 0, 0, 0.7)',
});

const emit = defineEmits(["dialog:visible"]);
const handleClose = () => {
  emit("dialog:visible", false);
};

onMounted(() => {});
</script>
<style lang="scss" scoped>
.dialog {
  --dialog-border: 2px solid rgba(255, 255, 255, 0.1);
  --dialog-body-bg: #11131a;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: normal !important;
  justify-content: normal !important;
  max-height: 100vh;
  
  &.align {
    align-items: center !important;
  }
  &.justify {
    justify-content: center !important;
  }
 
  .btn-close {
    // border: 1px solid #fff;
    // border-radius: 50%;
    width: 14px;
    height: 14px;
    text-align: center;
    position: absolute;
    top: 30px;
    right: 24px;
    cursor: pointer;
    color: #fff;
    z-index: 10000;
    line-height: 26px;
    font-size: 16px;
    
    img{
      width:14px;
      height:14px;
    }
  }
}
.dialog-inner {
  position: relative;
}
.dialog-border {
  border: var(--dialog-border);
  // box-shadow: 0 0 1px 0 #374151, 0 0 3px 0 #778191;
  border-radius: 10px;
}
.dialog-title {
  height: 48px;
  background-color: #000;
  border-radius: 16px 16px 0 0;
  display: flex;
  align-items: center;
  padding-left: 20px;
  color: var(--Ga7);
  font-size: 16px;
}
.dialog-body {
  position: relative;
  background-color: var(--dialog-body-bg);
  border-radius: 10px;
  padding-top: 24px;
  padding-bottom: 20px;
  overflow: auto;
  scrollbar-width: thin;
  .d-power {
    position: absolute;
    top: 45px;
    right: 45px;
    display: flex;
    align-items: center;
    background: #4d4d4d;
    height: 26px;
    padding: 0 18px;
    border-radius: 24px;
    font-size: 14px;
    cursor: pointer;
    color: #ffffff;
    font-weight: bold;
    .icon {
        width: 16px;
        height: 16px;
        margin-right: 4px;
        background: url(@/assets/images/power1.jpg) no-repeat center center;
        background-size: 100%;
    }
  }
}
</style>
